import {GoogleMapsController, initGoogleMaps} from '../../_layout/map';

const apiKey = window.sessionStorage.getItem('gmapApiKey');

if (apiKey) {
    const googleMapsController = GoogleMapsController(apiKey, document.querySelectorAll('[id^="gmap-"]'));
    initGoogleMaps(googleMapsController);
}
